import {branch, withHandlers, renderNothing, withProps} from 'recompose'

import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import withHook from '../../../../hocs/withHook'
import type {State} from '../../../../reducers/types'
import {getSingleBuildArg} from '../../../../rest/builds'
import {getBuildLocator} from '../../../../rest/locators'
import {getHrefWithQueryParams, withLocation} from '../../../../routes'
import {isBuildLoaded} from '../../../../selectors'
import {restApi} from '../../../../services/rest'
import type {BuildId} from '../../../../types'
import {queryToObject} from '../../../../utils/queryParams'

import CompareBuildsTabs from './CompareBuildsTabs'

type OwnProps = {
  sourceId: BuildId
  compareWithId: BuildId | null | undefined
}
type StateProps = {
  sourceBuildLoaded: boolean
}

const mapStateToProps = (state: State, {sourceId}: OwnProps): StateProps => ({
  sourceBuildLoaded: isBuildLoaded(state, sourceId),
})

export default compose(
  withLocation,
  withProps(({location}) => ({
    tab: queryToObject(location?.search).tab,
  })),
  connect(mapStateToProps, {}),
  withHook(({sourceId}: OwnProps) => {
    restApi.endpoints.getBuildNormalized.useQuerySubscription(
      getSingleBuildArg(getBuildLocator(sourceId)),
    )
  }),
  branch(
    (props: OwnProps & StateProps) => !props.sourceBuildLoaded || props.compareWithId == null,
    renderNothing,
  ),
  withHandlers({
    onTabSelect:
      ({location, navigate}) =>
      (tab: string) => {
        navigate(
          getHrefWithQueryParams(location, null, ({withBuildId}) => ({
            withBuildId,
            tab,
          })),
        )
      },
  }),
)(CompareBuildsTabs)
